import React from 'react';

import { useWorkflowEventQuery, WorkflowEventSource } from '@dashboard/generated/wp/platform';
import { CheckCircle, PreviewOutlined, WebhookOutlined } from '@mui/icons-material';

import WorkflowCard from '../WorkflowCard';

import CardCaption from './CardCaption';
import InputPreview from './InputPreview';

type Props = {
  id: string;
};
export default function TriggerCard({ id }: Props) {
  const { data } = useWorkflowEventQuery({ variables: { id } });
  const model = data?.WorkflowEvent;

  if (model === undefined) {
    return null;
  }

  const getLabelText = () => {
    switch (model.source) {
      case WorkflowEventSource.Preview:
        return 'Preview';
      case WorkflowEventSource.Api:
        return 'HTTP Request';
      case WorkflowEventSource.Trigger:
        return 'Trigger';
      case WorkflowEventSource.SandboxApi:
        return 'Sandbox API';
    }
  };
  const getLabelIcon = () => {
    switch (model.source) {
      case WorkflowEventSource.Preview:
        return <PreviewOutlined fontSize="small" />;
      case WorkflowEventSource.Api:
      case WorkflowEventSource.SandboxApi:
      case WorkflowEventSource.Trigger:
        return <WebhookOutlined fontSize="small" />;
    }
  };

  return (
    <WorkflowCard
      titleIcon={<CheckCircle sx={{ color: 'brand.green' }} />}
      titleText="Trigger"
      labelIcon={getLabelIcon()}
      labelText={getLabelText()}
      caption={<CardCaption id={model.id} />}
    >
      <InputPreview id={id} />
    </WorkflowCard>
  );
}
